// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import * as SagaBase from '../../../SagaBase';
import { TreeType } from '../../../SagaBase/Objects/TreeType';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListTreeTypes_abstract extends TreeType {
  static $t: string = 'SagaSchema.ListObjects.ListTreeTypes';
  $t: string = 'SagaSchema.ListObjects.ListTreeTypes';

  public static GetMembers(): string[] {
    return [].concat(TreeType.GetMembers());
  }

  public GetMembers(): string[] {
    return ListTreeTypes_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
